import { isAnyObject } from "@-/com.npmjs.is-what";

export function authErrorMessage(error: unknown): string {
  if (error == null) {
    return "Something went wrong.";
  }
  // Every Better Auth request has a deadline, so an expiry means the server never answered. Its own
  // message ("Better Auth <url> timed out after 20000ms") is for logs, not people. Checked by name,
  // like `describeFailureForUser`, so this helper needs no dependency on the deadline package.
  if (error instanceof Error && error.name === "DeadlineExceededError") {
    return "Haniverse isn't responding right now. Please try again.";
  }
  if (isAnyObject(error) && "message" in error) {
    const m = Reflect.get(error, "message");
    if (typeof m === "string" && m.length > 0) {
      return m;
    }
  }
  if (error instanceof Error && error.message.length > 0) {
    return error.message;
  }
  return "Something went wrong.";
}
